import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Login from '../components/auth/login'
import Registration from '../components/auth/registration'
import ForgotPassword from '../components/auth/ForgotPassword'
import ConfirmOtp from '../components/auth/ConfirmOtp'
import GetOtp from '../components/auth/GetOtp'
import PredictionView from "../components/prediction/PredictionView";
import Match from "../components/match/Match";
import AddMatch from "../components/match/AddMatch";
import AddTeam from "../components/team/addTeam";
import AddPlayer from "../components/player/addPlayer";
import Profile from "../components/profile";

import Blog from "../components/blog/Blog";
import Home from "../components/home/Home";
import AddBlog from "../components/blog/AddBlog";
import ViewBlog from "../components/blog/ViewBlog";
import PlayerList from "../components/player/playerList";
import TeamList from "../components/team/teamList";
import EditPlayer from "../components/player/editPlayer";
import AddPrediction from "../components/prediction/AddPrediction";
import About from "../components/about/About";
import Stats from "../components/stats/ComingSoon";
import Ledger from "../components/ledger/Ledger";
import Asma from "../components/asma";
import { lazy, Suspense } from 'react';
  import AsmaSorry from "../components/asma-sorry/AsmaSorry";
const BigBash = lazy(() => import('../components/bigbash/BigBash'));
const AsmaBirthday = lazy(() => import('../components/asma-bday/AsmaBirthday'));

function RequireAuth({ children }) {
    const token = localStorage.getItem('token');
    const location = useLocation();
    if (!token) {
        return <Navigate to="/login" state={{ from: `${location.pathname}${location.search}` }} replace />;
    }
    return children;
}

function router() {
    return (

        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/*" element={<Home />} />
            <Route path="/register" element={<Registration />} />
            <Route path="/login" element={<Login />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/profile" element={<RequireAuth><Profile /></RequireAuth>} />
            <Route path="/match" element={<RequireAuth><Match /></RequireAuth>} />
            <Route path="/blogs/add" element={<RequireAuth><AddBlog /></RequireAuth>} />
            <Route path="/blogs" element={<RequireAuth><Blog /></RequireAuth>} />
            <Route path="/blogs/view/:id" element={<RequireAuth><ViewBlog /></RequireAuth>} />
            <Route path="/prediction/add/:id" element={<RequireAuth><AddPrediction /></RequireAuth>} />
            <Route path="/prediction/view/:id" element={<RequireAuth><PredictionView /></RequireAuth>} />
            
            
            {/* <Route path="/forgotpassword" element={<ForgotPassword />} /> */}
            {/* <Route path="/getOTP" element={<GetOtp />} />
            <Route path="/confirmOTP" element={<ConfirmOtp />} /> */}
            <Route path="/prediction" element={<RequireAuth><Match /></RequireAuth>} />
            <Route path="/add-match" element={<RequireAuth><AddMatch /></RequireAuth>} />
            <Route path="/add-match/:id" element={<RequireAuth><AddMatch /></RequireAuth>} />
            <Route path="/add-team" element={<RequireAuth><AddTeam /></RequireAuth>} />
            <Route path="/add-player" element={<RequireAuth><AddPlayer /></RequireAuth>} />

            <Route path="/players" element={<RequireAuth><PlayerList /></RequireAuth>} />
            <Route path="/edit-player" element={<RequireAuth><EditPlayer /></RequireAuth>} />
            <Route path="/teams" element={<RequireAuth><TeamList /></RequireAuth>} />
            <Route path="/stats" element={<RequireAuth><Stats /></RequireAuth>} />
            <Route path="/page-stats" element={<RequireAuth><Stats /></RequireAuth>} />
            <Route path="/ledger" element={<RequireAuth><Ledger /></RequireAuth>} />
            <Route path="/asma" element={<Asma />} />
            <Route path="/asma-bday" element={<Suspense fallback={<p role="status">Wrapping your birthday surprise…</p>}><AsmaBirthday /></Suspense>} />
            <Route path="/bigbash" element={<Suspense fallback={<p role="status">Loading match explorer…</p>}><BigBash /></Suspense>} />
              <Route path="/asma-sorry" element={<AsmaSorry />} />

        </Routes>
    )
}

export default router;
